(function patchJdgmArrows() {
  function labelBtn(btn) {
    if (!btn.getAttribute('aria-label')) {
      // Depends on Judge.me's inline onclick string containing "Previous"
      // e.g. onclick="window.jdgmPreviousCard(...)". If Judge.me renames
      // this function, update the string check below accordingly.
      var onclick = btn.getAttribute('onclick') || '';
      btn.setAttribute(
        'aria-label',
        onclick.indexOf('Previous') !== -1 ? 'Previous review' : 'Next review'
      );
    }
  }
  function labelArrows() {
    document.querySelectorAll('.jdgm-arrow').forEach(labelBtn);
  }
  var arrowObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) {
          return;
        }
        if (node.matches && node.matches('.jdgm-arrow')) {
          labelBtn(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.jdgm-arrow').forEach(labelBtn);
        }
      });
    });
  });
  labelArrows();
  arrowObserver.observe(document.body, { childList: true, subtree: true });
})();

(function patchJdgmAllReviewsText() {
  function shortenText(span) {
    var count = span.getAttribute('data-number-of-reviews');
    if (!count) {
      return;
    }
    var anchor = span.querySelector('a');
    if (anchor && anchor.textContent.trim() !== count + ' reviews') {
      anchor.textContent = count + ' reviews';
    }
  }
  function patchAll() {
    document
      .querySelectorAll('.jdgm-all-reviews-text__text')
      .forEach(shortenText);
  }
  var textObserver = new MutationObserver(function () {
    patchAll();
  });
  patchAll();
  textObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();

// Judge.me star ratings (WCAG 4.1.2 / SC 1.1.1): the preview badge (.jdgm-prev-badge,
// shown on product cards and PDPs) and the review-widget summary/per-review star rows
// (.jdgm-rev__rating, .jdgm-rev-widg__summary-stars, .jdgm-star-rating / [data-score])
// render as bare glyph spans with no accessible name — VoiceOver announces nothing.
// This gives the star ROW role="img" + "Rated N out of 5 stars" and hides the
// individual .jdgm-star glyphs from assistive tech, without touching the
// .jdgm-form star PICKER (a live control a reviewer clicks to choose a rating —
// labelling or hiding its glyphs would break/obscure an interactive control).
(function patchJdgmStarRatings() {
  // Marks the source value (rating|count, or score) an element was last labelled
  // from, so a re-run is a no-op unless Judge.me's own data-* attrs changed.
  var PROCESSED_ATTR = 'data-a11y-star-src';
  // Marks that WE set the current aria-label (vs. one Judge.me set itself), so a
  // later data-score change knows it is safe to relabel.
  var LABEL_OWNER_ATTR = 'data-a11y-star-label-owner';

  function formatRating(raw) {
    var n = parseFloat(raw);
    if (isNaN(n)) {
      return null;
    }
    // '5.00' -> '5', '4.80' -> '4.8', '4.83' -> '4.83'
    return n.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
  }

  function reviewCountPhrase(count) {
    return count === 1 ? '1 review' : count + ' reviews';
  }

  function isTextReadable(el) {
    if (!el) {
      return false;
    }
    if (!el.textContent || !el.textContent.trim()) {
      return false;
    }
    if (
      el.hasAttribute('hidden') ||
      el.getAttribute('aria-hidden') === 'true'
    ) {
      return false;
    }
    var style = el.getAttribute('style') || '';
    return !/display\s*:\s*none/i.test(style);
  }

  function hideGlyphs(scope) {
    var glyphs = scope.querySelectorAll('.jdgm-star');
    for (var i = 0; i < glyphs.length; i++) {
      glyphs[i].setAttribute('aria-hidden', 'true');
    }
  }

  function inReviewForm(el) {
    return !!(el.closest && el.closest('.jdgm-form'));
  }

  function isInteractiveControl(el) {
    var tag = el.tagName;
    if (tag === 'A' || tag === 'BUTTON' || tag === 'INPUT') {
      return true;
    }
    var role = el.getAttribute('role');
    return (
      role === 'button' ||
      role === 'link' ||
      role === 'radio' ||
      role === 'option'
    );
  }

  // .jdgm-prev-badge: data-average-rating + data-number-of-reviews live on the
  // badge; the star glyphs sit in a .jdgm-prev-badge__stars child. Judge.me hides
  // badges with zero reviews, so a zero/blank count is skipped rather than
  // announced as "Rated 0".
  function patchBadges() {
    var badges = document.querySelectorAll('.jdgm-prev-badge');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      if (inReviewForm(badge)) {
        continue;
      }

      var reviewCount = parseInt(
        badge.getAttribute('data-number-of-reviews'),
        10
      );
      if (!reviewCount || reviewCount < 1) {
        continue;
      }

      var rating = formatRating(badge.getAttribute('data-average-rating'));
      if (rating === null) {
        continue;
      }

      var stars = badge.querySelector('.jdgm-prev-badge__stars');
      if (!stars) {
        continue;
      }

      var srcValue = rating + '|' + reviewCount;
      if (stars.getAttribute(PROCESSED_ATTR) === srcValue) {
        continue; // already labelled for this exact rating/count
      }

      var label = 'Rated ' + rating + ' out of 5 stars';
      var textEl = badge.querySelector('.jdgm-prev-badge__text');
      if (!isTextReadable(textEl)) {
        // Visible review-count text is missing/hidden, so fold the count into
        // the star row's own label instead of leaving it unannounced.
        label += ', ' + reviewCountPhrase(reviewCount);
      }

      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', label);
      stars.setAttribute(PROCESSED_ATTR, srcValue);
      hideGlyphs(stars);
    }
  }

  // Summary/per-review star rows. Judge.me's convention puts data-score directly
  // on the star container, e.g. <span class="jdgm-rev__rating" data-score="5">.
  function patchScoreContainers() {
    var els = document.querySelectorAll(
      '.jdgm-rev__rating, .jdgm-rev-widg__summary-stars, .jdgm-star-rating, [data-score]'
    );
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (inReviewForm(el) || isInteractiveControl(el)) {
        continue; // leave the review-form rating picker's stars alone
      }
      if (!el.closest || !el.closest('[class*="jdgm"]')) {
        continue; // bare [data-score] outside a Judge.me widget is not ours
      }
      if (el.closest('.jdgm-prev-badge')) {
        continue; // patchBadges() already owns the preview badge (and its stars child)
      }

      // Never turn a container with interactive content into role=img: its
      // children would become presentational. Live PDP evidence (2026-09-25):
      // the all_reviews_text app block puts data-score on BOTH the stars span
      // (.jdgm-all-reviews-rating) AND the count span wrapping the
      // "918 reviews" link (.jdgm-all-reviews-text__text) - only the former
      // is a rating graphic.
      if (el.querySelector('a, button, input, select, textarea, [tabindex]')) {
        // Judge.me can insert the link AFTER an earlier pass labelled this
        // element, so re-check on every pass and give back a label we set:
        // a role=img wrapper would hide the "N reviews" link from VoiceOver.
        if (el.getAttribute(LABEL_OWNER_ATTR) === 'true') {
          el.removeAttribute('role');
          el.removeAttribute('aria-label');
          el.removeAttribute(LABEL_OWNER_ATTR);
          el.removeAttribute(PROCESSED_ATTR);
        }
        continue;
      }

      var score = el.getAttribute('data-score');
      if (score === null) {
        continue;
      }

      if (el.getAttribute(PROCESSED_ATTR) === score) {
        continue; // already labelled for this exact score
      }

      // Never clobber a meaningful aria-label Judge.me set itself. We only ever
      // overwrite a label we set ourselves on a prior run (tracked by
      // LABEL_OWNER_ATTR) — if Judge.me owns the label, it stays Judge.me's for
      // the life of the element, even across a later data-score change.
      var weOwnLabel = el.getAttribute(LABEL_OWNER_ATTR) === 'true';
      if (!el.hasAttribute('aria-label') || weOwnLabel) {
        // Prefer the score Judge.me SHOWS (all_reviews_text renders
        // data-score 4.84 as "4.8") so VoiceOver matches what sighted users see.
        var shownScoreEl = el.querySelector('[class$="__score"]');
        var shown = shownScoreEl
          ? formatRating(shownScoreEl.textContent)
          : null;
        var rating = shown !== null ? shown : formatRating(score);
        if (rating !== null) {
          el.setAttribute('role', 'img');
          el.setAttribute('aria-label', 'Rated ' + rating + ' out of 5 stars');
          el.setAttribute(LABEL_OWNER_ATTR, 'true');
        }
      }

      el.setAttribute(PROCESSED_ATTR, score);
      hideGlyphs(el);
    }
  }

  function patchJdgmStars() {
    patchBadges();
    patchScoreContainers();
  }

  patchJdgmStars();
  // Coalesce bursts of mutations (PDPs mutate constantly while the
  // configurator runs) into at most one pass per animation frame.
  var starPassQueued = false;
  var starObserver = new MutationObserver(function () {
    if (starPassQueued) {
      return;
    }
    starPassQueued = true;
    requestAnimationFrame(function () {
      starPassQueued = false;
      patchJdgmStars();
    });
  });
  starObserver.observe(document.body, { childList: true, subtree: true });
})();
